<template>
    <p v-if="fonds" class="belegd-vermogen">Pensioenfonds {{fonds.fonds}} heeft een belegd vermogen van € {{fonds.beleggingen | formatNumber1000}}.</p>
    <p v-else>Belegd vermogen van dit fonds in onbekend.</p>
</template>

<script>
    export default {
        name: "BelegdVermogen",
        props: {
            fonds: Object
        }
    }
</script>

<style scoped>

</style>